<div *ngIf="!showReturn" class="invoice">
  <!-- states -->
  <div *ngIf="loading()" class="state loading">Loading…</div>
  <div *ngIf="!loading() && error()" class="state error">{{ error() }}</div>

  <ng-container *ngIf="!loading() && !error() && invSig() as inv">
    <!-- header -->
    <header class="header">
      <div>
        <h3 class="title">{{ inv.name || 'Invoice' }}</h3>
        <div class="badges">
          <span class="badge" [class.posted]="inv.isPosted" [class.draft]="inv.state === 'draft'" [class.cancel]="inv.state === 'cancel'">
            {{ inv.state | uppercase }}
          </span>
          <span class="badge" [class.paid]="inv.isPaid" [class.partial]="inv.isPartial" [class.inpay]="inv.isInPayment">
            {{ inv.paymentState | uppercase }}
          </span>
        </div>
      </div>
      <div class="actions">
        <button class="btn" type="button" (click)="onCollectClick()" [disabled]="isCollectPaymentDisabled()">Collect Payment</button>
        <button class="btn secondary" type="button" (click)="onShowReturn()" [disabled]="isReturnDisabled()">Returns</button>
      </div>
    </header>

    <!-- meta -->
    <div class="meta-grid">
      <div><label>Date</label><div>{{ inv.invoiceDate || '—' | date:'dd/MM/yyyy' }}</div></div>
      <div><label>Due</label><div>{{ inv.invoiceDueDate || '—'  | date:'dd/MM/yyyy'}}</div></div>
      <div><label>Journal</label><div>{{ inv.journal || '—' }}</div></div>
      <div><label>Salesperson</label><div>{{ inv.salesperson || '—' }}</div></div>
      <div><label>Sales Order</label><div>{{ inv.salesOrder || '—' }}</div></div>
    </div>

    <!-- customer -->
    <section class="card" *ngIf="showCustomer">
      <div class="card-head">
        <h4>Customer</h4>
        <button
          class="btn secondary small"
          type="button"
          (click)="openMap()"
          [disabled]="!hasCoords()"
          title="Open in Maps"
        >
          Open Map
        </button>
      </div>

      <div class="grid2">
        <div>
          <label>Invoice To</label>
          <div>
            {{ inv.partnerName || '—' }}
            <small *ngIf="inv.partnerId">#{{ inv.partnerId }}</small>
          </div>
        </div>
        <div>
          <label>Commercial Partner</label>
          <div>
            {{ inv.commercialPartnerName || '—' }}
            <small *ngIf="inv.commercialPartnerId">#{{ inv.commercialPartnerId }}</small>
          </div>
        </div>
      </div>
    </section>

    <!-- totals -->
    <section class="totals">
      <div class="total grand">
        <label>Total</label>
        <div>{{ inv.totals.amountTotal | currency: currency() : 'symbol' : '1.2-2' }}</div>
      </div>
      <div class="total">
        <label>Total Credits</label>
        <div>{{ (inv.totals.totalCredits || 0) | currency: currency() : 'symbol' : '1.2-2' }}</div>
      </div>
      <div class="total">
        <label>Tax</label>
        <div>{{ inv.totals.amountTax | currency: currency() : 'symbol' : '1.2-2' }}</div>
      </div>      
      <div class="total" [class.zero]="inv.totals.amountResidual === 0">
        <label>Balance</label>
        <div>{{ inv.totals.amountResidual | currency: currency() : 'symbol' : '1.2-2' }}</div>
      </div>
    </section>

    <!-- lines -->
    <section class="card">
      <div class="card-head">
        <h4>Lines</h4>
        <span class="muted" *ngIf="!hasLines()">No lines</span>
      </div>
      <div class="table-wrap" *ngIf="hasLines()">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Description</th>
              <th class="num">Qty</th>
              <th class="num">Unit</th>
              <th class="num">Disc %</th>
              <th class="num">Subtotal</th>
              <th class="num">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let l of inv.lines; trackBy: trackLine; let i = index">
              <td>{{ i + 1 }}</td>
              <td>
                <div class="desc">{{ l.name || l.productName || '—' }}</div>
                <!-- ✅ Pure template join for tax names -->
                <div class="subdesc" *ngIf="l.taxes?.length">
                  Taxes:
                  <ng-container *ngFor="let t of l.taxes; let last = last">
                    {{ t.name }}<span *ngIf="!last">, </span>
                  </ng-container>
                </div>
              </td>
              <td class="num">{{ l.quantity }}</td>
              <td class="num">{{ l.priceUnit | currency: currency() : 'symbol' : '1.2-2' }}</td>
              <td class="num">{{ l.discount || 0 }}</td>
              <td class="num">{{ l.priceSubtotal | currency: currency() : 'symbol' : '1.2-2' }}</td>
              <td class="num">{{ l.priceTotal | currency: currency() : 'symbol' : '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- payments -->
    <section class="card" *ngIf="showPayments">
      <div class="card-head">
        <h4>Payments</h4>
        <span class="muted" *ngIf="!hasPayments()">No payments</span>
      </div>
      <div class="table-wrap" *ngIf="hasPayments()">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Journal</th>
              <th>Ref</th>
              <th>Move</th>
              <th class="num">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of inv.payments; trackBy: trackPay">
              <td>{{ p.date || '—' }}</td>
              <td>{{ p.journal || '—' }}</td>
              <td>{{ p.ref || '—' }}</td>
              <td>{{ p.moveName || p.name || '—' }}</td>
              <td class="num">{{ p.amount | currency: currency() : 'symbol' : '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </ng-container>
</div>

<app-return *ngIf="showReturn"
            [customer]="selectedCustomer"
            [returnItems]="returnItems"
            [loadId]="loadId"
            [invoiceId]="invoiceId"
            (itemsChange)="onReturnItemsChange($event)"
            (returnCreated)="onReturnCreated()">
</app-return>

<button mat-raised-button color="accent"
        class="full-width close-button"
        (click)="closeDetails()">
  Close Details
</button>
